import React from "react";
import StandardSkeletoon from "../../../../components/reusable/loader/StandardSkeletoon";
import { Grid } from "@mui/material";

const FicheLoader = ({ show = false }) => {
  return (
    <Grid m={3} display={show ? "" : "none"}>
      <StandardSkeletoon row={4} show={show} />
    </Grid>
  );
};

export default FicheLoader;
